import React from 'react';

interface AsideItemProps {
  item: {
    id: string;
    name: string;
    description: string;
  };
  isSelected?: boolean;
  onClick?: () => void;
}

const AsideItem: React.FC<AsideItemProps> = ({ item, isSelected, onClick }) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className={`min-w-48 shrink-0 cursor-pointer rounded-lg border p-3 lg:min-w-0 lg:w-full lg:shrink ${isSelected ? 'border-sky-500 bg-sky-50' : 'border-neutral-200 hover:border-neutral-300 hover:bg-neutral-050'}`}
      data-testid={`play-item-${item.id}`}
      aria-label={`Select ${item.name}`}
      aria-pressed={isSelected}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className="font-medium text-primary">{item.name}</div>
      <div className="text-sm text-tertiary">{item.description}</div>
    </div>
  );
};

export default AsideItem;
